import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';

import { addZero, checkCurrentTime } from '../../../utils/gas-datepicker-directive/datepicker.helper';

const SEPARATOR = ':';

@Component({
  selector: 'gas-time',
  templateUrl: './gas-time.component.html',
  styleUrls: ['./gas-time.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasTimeComponent implements OnChanges {

  @Input()
  public timeWithoutSeconds = false;

  @Input()
  public currentDate: Date;

  @Output('onSelectedDate')
  public onSelectedDate$ = new EventEmitter<string[]>();

  @Output('onCloseDatePicker')
  public onCloseDatePicker$ = new EventEmitter<void>();

  public inputForm = new FormControl();

  public currentTimes: string[] = [];

  public ngOnChanges(changes: SimpleChanges): void {
    if (!this.currentDate) {
      this.inputForm.setValue('');
      return;
    }

    this.inputForm.setValue(checkCurrentTime([...this.getZeroTimeArray(this.currentDate)]));
    this.currentTimes = this.inputForm.value.split(SEPARATOR);
  }

  public setDate(): void {
    this.onSelectedDate$.emit(this.currentTimes);
  }

  public closeDatePicker(): void {
    this.onCloseDatePicker$.emit();
  }

  public changeTimeHandler(): void {
    this.currentTimes = checkCurrentTime(this.inputForm.value.split(SEPARATOR))
      .split(SEPARATOR);
  }

  public get digitsMask(): string {
    return this.getSeparatedCharacters('__');
  }

  public get placeHolder(): string {
    return this.getSeparatedCharacters('00');
  }

  private get timePartCounter(): number {
    return this.timeWithoutSeconds ? 2 : 3;
  }

  private getSeparatedCharacters(characters: string): string {
    return new Array<string>(this.timePartCounter)
      .fill(characters)
      .join(` ${SEPARATOR} `);
  }

  private getZeroTimeArray(date: Date): string[] {
    return [date.getHours(), date.getMinutes(), date.getSeconds()]
      .splice(0, this.timePartCounter)
      .map(timePartItem => addZero(timePartItem));
  }
}
